<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">{{ $t('话题讨论标签.话题讨论标签') }}</span>
        <div class="head-text">
          <el-button type="primary" @click="
            dialogVisible = true;
          isAdd = true;
          ">{{ $t('common.添加') }}</el-button>
          <el-button type="danger" @click="Delptopicset2">{{ $t('common.删除') }}</el-button>
        </div>
      </div>
      <div class="rygl-table">
        <el-table :data="tableData" class="width100" height="72vh" @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" prop="ptps03" :label="$t('话题讨论标签.类型')"></el-table-column>
          <el-table-column align="center" prop="ptps04" :label="$t('话题讨论标签.图片')">
            <template slot-scope="scope">
              <img :src="$store.state.baseUrl + scope.row.ptps04" width="30px" height="30px" alt />
            </template>
          </el-table-column>
          <el-table-column :label="$t('话题讨论标签.操作')" align="center">
            <template slot-scope="scope">
              <el-button type="primary" plain size="small" @click="upadataLive(scope.row)">{{ $t('common.修改')
              }}</el-button>
              <el-button type="danger" plain size="small" @click="Delptopicset2(scope.row)">{{ $t('common.删除')
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <el-dialog :close-on-click-modal="false" :title="$t('话题讨论标签.添加标签')" :visible.sync="dialogVisible" width="40%">
      <el-row class="h100p">
        <el-col :span="6">
          <el-input v-model="value" :placeholder="$t('话题讨论标签.类型')"></el-input>
        </el-col>
        <el-col :span="6" :offset="3">
          <el-upload class="upload-demo" ref="upload" :action="actionUrl" :before-upload="handleBefore"
            :file-list="fileList" :data="aaa" :on-exceed="handleExceed" :headers="importHeaders"
            :on-success="handleSuccess">
            <el-button slot="trigger" type="primary">{{ $t('话题讨论标签.选取文件') }}</el-button>
          </el-upload>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :title="$t('话题讨论标签.修改标签')" :visible.sync="dialogVisible2" width="40%">
      <el-row class="h100p">
        <el-col :span="6">
          <el-input v-model="value2" :placeholder="$t('话题讨论标签.类型')"></el-input>
        </el-col>
        <el-col :span="6" :offset="3">
          <el-upload class="upload-demo" ref="upload2" :action="actionUrl2" :limit="1" :on-exceed="handleExceed"
            :before-upload="handleBefore2" :on-change="handleChange2" :file-list="fileList2" :data="bbb"
            :headers="importHeaders" :on-success="handleSuccess" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">{{ $t('话题讨论标签.选取文件') }}</el-button>
          </el-upload>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" :offset="15">
          <el-button type="primary" @click="updataToptic">{{ $t('common.确定') }}</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { GetptopicsetList, Delptopicset, UpdatePtopicset } from "@/setAxios";
export default {
  data() {
    return {
      ptps01: "",
      isAdd: false,
      multipleSelection: [],
      actionUrl: this.$store.state.baseUrl + "/api/Addptopicset",
      actionUrl2: this.$store.state.baseUrl + "/api/UpdatePtopicset",
      dialogVisible: false,
      dialogVisible2: false,
      options: [
        {
          value: 1,
          label: "图片",
        },
        {
          value: 2,
          label: "全景",
        },
        {
          value: 3,
          label: "视频",
        },
      ],
      value: "",
      value2: "",
      imgUrl: "",
      fileList: [],
      fileList2: [],
      aaa: {},
      bbb: {},
      importHeaders: { token: localStorage.getItem("token") },
      tableData: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.GetModelLableSets2();
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        this.$t('common.只能选择一个'));
    },
    updataToptic() {
      if (this.fileList2.length > 0) {
        this.$refs.upload2.submit();
        this.GetModelLableSets2();
      } else {
        let params = {
          xid: localStorage.getItem("xid"),
          qid: localStorage.getItem("pid"),
          id: this.ptps01,
          name: this.value2,
        };
        UpdatePtopicset({ ...params }).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: this.$t('common.处理成功'),
            });
            this.dialogVisible2 = false;
            this.GetModelLableSets2();
          }
        });
      }
    },
    Delptopicset2(row) {
      let params = {
        ptopid: row.ptps01,
      };
      this.$confirm(this.$t('common.删除询问'), this.$t('common.提示'), {
        confirmButtonText: this.$t('common.确定'),
        cancelButtonText: this.$t('common.取消'),
        type: "warning",
      }).then(() => {
        Delptopicset({ ...params }).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: this.$t('common.处理成功')
            });
            this.GetModelLableSets2();
          }
        });
      });
    },
    upadataLive(row) {
      this.dialogVisible2 = true;
      this.value2 = row.ptps03;
      this.ptps01 = row.ptps01;
    },
    GetModelLableSets2() {
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetptopicsetList({ params }).then((res) => {
        this.tableData = res.Data.list;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleBefore(file) {
      if (this.value.trim() == "") {
        this.$message.error(this.$t('common.请填写必填项'));
        return false;
      }
      var testmsg = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      const extension = testmsg == "jpg";
      const extension2 = testmsg == "png";
      const isLt2M = file.size / 1024 / 1024 <= 2;
      if (!extension && !extension2) {
        this.$message({
          message: this.$t('common.上传类型错误'),
          type: "warning",
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 2MB!",
          type: "warning",
        });
        return false;
      }
      let fd = new FormData();
      this.aaa.xid = localStorage.getItem("xid");
      this.aaa.qid = localStorage.getItem("pid");
      this.aaa.name = this.value;
      this.aaa.uid = localStorage.getItem("id");
      fd.append("file", file);
      fd.append("model", this.aaa);
    },
    handleBefore2(file) {
      if (this.value2.trim() == "") {
        this.$message.error(this.$t('common.请填写必填项'));
        return false;
      }
      var testmsg = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      const extension = testmsg == "jpg";
      const extension2 = testmsg == "png";
      const isLt2M = file.size / 1024 / 1024 <= 2;
      if (!extension && !extension2) {
        this.$message({
          message: this.$t('common.上传类型错误'),
          type: "warning",
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 2MB!",
          type: "warning",
        });
        return false;
      }
      let fd = new FormData();
      this.bbb.xid = localStorage.getItem("xid");
      this.bbb.qid = localStorage.getItem("pid");
      this.bbb.name = this.value2;
      this.bbb.id = this.ptps01;
      fd.append("file", file);
      fd.append("model", this.bbb);
    },
    handleChange2(file, filelist) {
      this.fileList2 = filelist;
    },
    handleSuccess(response, file, fileList) {
      if (response.Code > 0) {
        // this.imgUrl = this.$store.state.baseUrl + res.Data;
        this.$message({
          type: "success",
          message: this.$t('common.处理成功')
        });
        if (this.isAdd) {
          this.dialogVisible = false;
        } else {
          this.dialogVisible2 = false;
        }
        this.GetModelLableSets2();
        this.$refs.upload.clearFiles();
      }
    },
    handleSuccess2(response, file, fileList) {
      if (response.Code > 0) {
        // this.imgUrl = this.$store.state.baseUrl + res.Data;
        this.$message({
          type: "success",
          message: this.$t('common.处理成功')
        });
        if (this.isAdd) {
          this.dialogVisible = false;
        } else {
          this.dialogVisible2 = false;
        }
        this.GetModelLableSets2();
      }
    },
  },
};
</script>
<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}

.head-text {
  float: right;
  margin-top: -4px;
}

.width100 {
  width: 100%;
}

.h100p {
  height: 100px;
}
</style>
